export default __webpack_public_path__ + "static/media/12wbtlogo.7fd4140f.png";